export default __webpack_public_path__ + "static/media/take-away-disabled.d699906a.svg";